import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Seo from '@molecules/Seo/Seo';
import VacancyDetail from '@organisms/VacancyDetail/VacancyDetail';
import withDomainServerSideProps from '@lib/withDomainServerSideProps';

const VacancyPage = ({ vacancy, host }) => {
  const { title, metaTitle, metaDescription, backgroundImage } = vacancy;
  const pageTitle = metaTitle || title;

  return (
    <>
      <Seo
        title={pageTitle}
        description={metaDescription}
        image={backgroundImage?.contentUrl}
      />
      <VacancyDetail host={host} vacancy={vacancy} />
    </>
  );
};

export const getServerSideProps = withDomainServerSideProps(
  async ({ query, req, res, locale }) => {
    // Cache this SSR page using cache control, https://web.dev/stale-while-revalidate/
    res.setHeader(
      'Cache-Control',
      'public, s-maxage=300, stale-while-revalidate=600'
    );

    // Get the vacancy id from the url
    const { id } = query;
    const { host } = req.headers;

    // Fetch vacancy details
    return axios
      .get(`${process.env.BACKEND_ENDPOINT}/vacancies/${id}`)
      .then(async response => ({
        props: {
          host,
          vacancy: {
            queryId: id,
            ...response.data,
          },
          ...(await serverSideTranslations(locale, ['common', 'vacancy'])),
        },
      }))
      .catch(() => ({
        notFound: true,
      }));
  }
);

export default VacancyPage;

VacancyPage.propTypes = {
  vacancy: PropTypes.object.isRequired,
  host: PropTypes.string.isRequired,
};
